/** Check this link before editing https://material.angular.io/components/dialog/api */

// Angular
import { Component, Inject, Input } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ISegment } from "libraries/service/resources/airTrip/IGetAirTripQuotes";
import { ILabels } from "libraries/interfaces/ILabels";
import { Yii } from "../../../libraries/interfaces/Yii";
import { NotificationType } from "libraries/interfaces/INotification";
import { faClipboard, IconDefinition } from "@fortawesome/free-solid-svg-icons";

export interface IDetailsDialogData {
    plainText: string;
    details: ISegment[];
}

@Component({
    selector: 'confirm-dialog',
    template: `
        <card [@.disabled]="true" mat-dialog-content>
            <header class="card-header-content">
                <h1>{{ wording.title }}</h1>
                <div class="btn-container">
                    <btn type="actionLink" [label]="wording.html" (click)="toggleText()" *ngIf="showText"></btn>
                    <btn type="actionLink"
                         [label]="wording.text"
                         *ngIf="!showText"
                         ngxClipboard
                         [cbContent]="data.plainText"
                         (cbOnSuccess)="copyThenShowText()"
                         (cbOnError)="errorThenShowText()">
                        <span class="icon"><fa-icon [icon]="iconClipboard"></fa-icon></span>
                    </btn>
                    <btn type="actionDo"
                         [label]="wording.copy"
                         *ngIf="showText"
                         ngxClipboard
                         [cbContent]="data.plainText"
                         (cbOnSuccess)="showSuccess = true">
                        <span class="icon"><fa-icon [icon]="iconClipboard"></fa-icon></span>
                    </btn>
                    <btn type="actionDo" [label]="wording.close" (click)="close()"></btn>
                </div>
            </header>
            <div class="card-body-content">
                <notification *ngIf="showSuccess" [type]="notificationType.Success">{{wording.textCopied}}</notification>
                <notification *ngIf="showError" [type]="notificationType.Warning">{{wording.textNotCopied}}</notification>
                <segment-list [segmentList]="data.details" *ngIf="!showText"></segment-list>
                <pre *ngIf="showText">{{data.plainText}}</pre>
            </div>
        </card>
    `,
    styles: [`
        .card-body-content{
            padding: 15px 15px 0 15px;
        }
    `]
})
export class DetailsDialogComponent {

    public showText: boolean = false;
    public showSuccess: boolean = false;
    public showError: boolean = false;
    public notificationType: typeof NotificationType = NotificationType;
    public iconClipboard: IconDefinition = faClipboard;

    public wording: ILabels = {
        title: Yii.t('wui-iqba-js', 'Détail des vols'),
        close: Yii.t('wui-iqba-js', 'Fermer'),
        copy: Yii.t('wui-iqba-js', 'Copier'),
        html: Yii.t('wui-iqba-js', 'Format HTML'),
        text: Yii.t('wui-iqba-js', 'Format Texte'),
        textCopied: Yii.t('wui-iqba-js', `L'itinéraire au format texte a bien été copié.`),
        textNotCopied: Yii.t('wui-iqba-js', `L'itinéraire au format texte n'a pas été copié.`),
    };

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IDetailsDialogData,
        private readonly dialogRef: MatDialogRef<DetailsDialogComponent>
    ) { }

    public close(): void {
        this.dialogRef.close('process');
    }

    public toggleText(): void {
        this.showText = !this.showText;
        if (!this.showText) {
            this.showSuccess = false;
        }
    }

    public copyThenShowText(): void {
        this.showText = true;
        this.showSuccess = true;
    }
    public errorThenShowText(): void {
        this.showText = true;
        this.showError = true;
    }
}
